module.exports = __webpack_public_path__ + "img/allianz-turkish-movie-07.9e57ae80.jpg";